import JelWorkspace from '@/store/classes/jelWorkspace';

import { getStatutDesactivation } from '@/helpers/ProduitHelpers';

const jelWorkspace = new JelWorkspace({
  module: 'integrateur',
  // On prend volontairement le même délai que le fournisseur
  refreshMinProd: process.env.VUE_APP_STORE_FOURNISSEUR_REFRESH_MIN,
  refreshMinDev: process.env.VUE_APP_STORE_DEV_REFRESH_MIN,
});

const state = {
  ...jelWorkspace.state,
};
const getters = {
  ...jelWorkspace.getters,
  getStatutIntegrateur: (state, getters, rootState, rootGetters) => (integrateurUuid, isMobile) => {
    const integrateur = getters.getByUuid(integrateurUuid);
    if (integrateur) {
      const statutIntegrateur = getStatutDesactivation(integrateur, isMobile);
      return statutIntegrateur;
    }
    return null;
  },
};
const actions = {
  ...jelWorkspace.actions,
};
const mutations = {
  ...jelWorkspace.mutations,
  async INIT(state) {
    if (!state.isLoaded) {
      this.commit(`${state.module}/INTERNAL_INIT`);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
